export default __webpack_public_path__ + "static/media/Agros.22e37987.png";